import React, { useEffect, useMemo } from "react";
import classnames from "classnames";
import Image from "../image";
var classPrefix = "tc-uploader";
var PreviewItem = function PreviewItem(props) {
  var status = props.status,
    url = props.url,
    file = props.file,
    imageFit = props.imageFit,
    deletable = props.deletable,
    deleteIcon = props.deleteIcon,
    loadingIcon = props.loadingIcon,
    _props$loadingTips = props.loadingTips,
    loadingTips = _props$loadingTips === void 0 ? "上傳中..." : _props$loadingTips,
    failIcon = props.failIcon,
    _props$failTips = props.failTips,
    failTips = _props$failTips === void 0 ? "上傳失敗" : _props$failTips,
    onClick = props.onClick,
    onReSet = props.onReSet,
    onDelete = props.onDelete;
  var src = useMemo(function () {
    if (url) return url;
    if (file) return URL.createObjectURL(file);
    return "";
  }, [url, file]);
  useEffect(function () {
    return function () {
      if (file) {
        URL.revokeObjectURL(src);
      }
    };
  }, [src, file]);
  function renderLoading() {
    return status === "uploading" && /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-cell-mask")
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classPrefix, "-cell-loading")
    }, loadingIcon, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classPrefix, "-cell-mask-message")
    }, loadingTips)));
  }
  function renderFail() {
    return status === "error" && /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-cell-mask"),
      onClick: onReSet
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classPrefix, "-cell-fail")
    }, failIcon, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classPrefix, "-cell-mask-message")
    }, failTips)));
  }
  function renderDelete() {
    return deletable && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classPrefix, "-cell-delete"),
      onClick: onDelete
    }, deleteIcon);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(classPrefix, "-cell"))
  }, /*#__PURE__*/React.createElement(Image, {
    className: "".concat(classPrefix, "-cell-image"),
    style: {
      "--width": "var(--upload-width))",
      "--height": "var(--upload-height)"
    },
    src: src,
    fit: imageFit,
    onClick: onClick
  }), renderLoading(), renderFail(), renderDelete());
};
export default PreviewItem;